import { supabase } from "@/integrations/supabase/client";

export type PickAccessRow = {
  pick_id: string;
  can_access: boolean;
  access_reason: string;
  is_locked: boolean;
  is_free_pick: boolean;
  user_tier: string;
};

export async function fetchPickAccessMap(userId: string, start?: string, end?: string, onlyConcluded = false, top5Only = false, pickIds?: string[]) {
  const { data, error } = await supabase.rpc("get_pick_access_rows", {
    _uid: userId,
    _start_ts: start ?? null,
    _end_ts: end ?? null,
    _only_concluded: onlyConcluded,
    _top5_only: top5Only,
  });
  if (error) throw error;
  const pickIdSet = pickIds?.length ? new Set(pickIds) : null;
  const rows = ((data ?? []) as PickAccessRow[]).filter((r) => !pickIdSet || pickIdSet.has(r.pick_id));
  return new Map(rows.map((r) => [r.pick_id, r]));
}

export async function fetchPickAccessForPick(userId: string, pickId: string) {
  const { data, error } = await supabase.rpc("get_pick_access_for_pick", {
    _uid: userId,
    _pick_id: pickId,
  });
  if (error) throw error;
  return ((data ?? [])[0] ?? null) as PickAccessRow | null;
}
